import { faIndustry, faLocationPin, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import theme from '~/design'

const mapIcons = {
  pin: {
    preferredColor: theme.colors.primary,
    svg: {
      definition: faLocationPin,
    },
    gltf: {
      url: '/pin.gltf',
    },
  },
  industry: {
    preferredColor: theme.colors.primary,
    svg: {
      definition: faIndustry,
    },
    gltf: {
      url: '/pin.gltf', // TODO: change to industry.gltf
    },
  },
  exclamation: {
    preferredColor: theme.colors.secondary,
    svg: {
      definition: faTriangleExclamation,
    },
    gltf: {
      url: '/exclamation.gltf',
    },
  },
} as const

export type MapIcon = keyof typeof mapIcons

export default mapIcons
